/**
 * Brazilian Portuguese catalog. Each namespace is typed against the English
 * source of truth (`Messages['<ns>']`), so key drift fails `tsc`, not runtime.
 */

import type { Messages } from '../en'
import { access } from './access'
import { beats } from './beats'
import { common } from './common'
import { errors } from './errors'
import { feedback } from './feedback'
import { flows } from './flows'
import { home } from './home'
import { journey } from './journey'
import { login } from './login'
import { memories } from './memories'
import { newRun } from './newRun'
import { run } from './run'
import { runs } from './runs'
import { shell } from './shell'
import { theater } from './theater'

export const ptBR: Messages = {
  common,
  shell,
  login,
  beats,
  journey,
  theater,
  home,
  flows,
  memories,
  access,
  newRun,
  runs,
  run,
  feedback,
  errors
}
